
















import firebase, { firestore, functions } from "firebase";
import { Component, Prop, Vue } from 'vue-property-decorator';
import * as uuid from 'uuid'
import { MDDocument, MDCloudStatus } from '@/struct/mddocument';

@Component
export default class MarkdownEditForm extends Vue {
  @Prop() document!: MDDocument
  @Prop() status!: MDCloudStatus

  get cloud_working(): boolean {
    return this.status.saving || this.status.getting
  }

  kup(event: Event) {
    console.log(event)
    if (event instanceof KeyboardEvent) {
      const keyWith = {
        meta: event.metaKey,
        ctrl: event.ctrlKey,
        alt: event.altKey,
        shift: event.shiftKey,
      }
      switch (event.key) {
      case "Escape":
        event.preventDefault()
        this.$emit("editor-keypress", { action: "back" })
        break
      case "s":
        if (keyWith.meta || keyWith.ctrl) {
          event.preventDefault()
          this.$emit("editor-keypress", { action: "cloudsave" })
        }
        break
      case "i":
      case "b":
      case "k":
        const ta = this.$refs.ta
        console.log(ta)
        const paren = {
          b: "**", i: "*", k: "~~",
        }[event.key]
        if ((keyWith.meta || keyWith.ctrl) && (ta instanceof HTMLTextAreaElement) && paren) {
          event.preventDefault()
          const ss = ta.selectionStart, se = ta.selectionEnd
          if (typeof ss === "number" && typeof se === "number") {
            console.log({ 
              selectionStart: ss, 
              selectionEnd: se, 
              value: ta.value,
              sv: ta.value.substring(ss,se)
            })
            const s: string = ta.value
            const v = paren + s.substring(ss,se) + paren
            document.execCommand("insertText", false, v)
          }
        }
        break
      }
    }
  }
}
